/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const es_accounts_us_empty_title = /** @type {(inputs: {}) => string} */ () => {
	return `Aún no tienes una cuenta USD.`
};

const en_accounts_us_empty_title = /** @type {(inputs: {}) => string} */ () => {
	return `You don't have a USD account yet.`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
const accounts_us_empty_title = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.accounts_us_empty_title(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("accounts_us_empty_title", locale)
	if (locale === "es") return es_accounts_us_empty_title(inputs)
	return en_accounts_us_empty_title(inputs)
};
export { accounts_us_empty_title as "accounts.us.empty_title" }